module.exports = __webpack_public_path__ + "img/SDG-12.30978743.svg";